import React from "react";
import { observer } from "mobx-react";
import SideNavLink from "../../../../shared/SideNavLink";
import { MonitorContext } from "../../Monitor";
import "./SideNav.scss";
import { SidebarContext } from "../Sidebar/Sidebar";
import { useStore } from "../../../../AppStore";

export default observer(function SideNav() {
  const monitorStore = React.useContext(MonitorContext).store; // todo: use history context
  const sidebarStore = React.useContext(SidebarContext);
  const appStore = useStore();

  const SideNavLinks = [
    { key: "events", icon: "alarm-medium" },
    {
      key: "patients",
      disabled:
        monitorStore.routeParams?.historyType?.match(/event/) ||
        appStore.patientStore?.isCustomBedList,
    },
  ];

  return (
    <div className="pm-side-nav">
      {SideNavLinks.map((link) => (
        <SideNavLink
          className={link.key}
          key={link.key}
          icon={link.icon || link.key}
          href={link.key}
          onClick={(e) => {
            e.preventDefault();
            sidebarStore.selection = link.key;
          }}
          selected={sidebarStore.selection === link.key}
          disabled={link.disabled}
        />
      ))}
    </div>
  );
});
